import { useContext } from 'react';

import { IDotsMenuItem } from '@smartshell/ui-kit';

import { useIsFeatureAvailable } from 'features';
import { LocalizationContext } from 'localization';
import { openConfirmDialog } from 'services/Confirmation';
import { TGameAccountsGroup } from 'types';

import { GameAccountsContext } from '../../GameAccounts';
import { IReturnDotsMenuItemsValue } from '../../interfaces';

export const useDotsMenuItems = (): IReturnDotsMenuItemsValue => {
  const { t } = useContext(LocalizationContext);
  const {
    deleteAccountsGroup,
    setAccountsGroupForEdit,
    openAccountsGroupManager,
    openAccountManager,
  } = useContext(GameAccountsContext) ?? {};
  const isAvailable = useIsFeatureAvailable('game_accounts');

  const items: Array<IDotsMenuItem<TGameAccountsGroup>> = [
    {
      key: 'add',
      text: t('accounts.add'),
      iconName: 'CirclePlusIcon',
      disabled: !isAvailable,
      onClick: (data) => {
        if (!openAccountManager) {
          return;
        }

        openAccountManager(data);
      },
    },
    {
      key: 'edit',
      text: t('group.edit'),
      iconName: 'EditIcon',
      disabled: !isAvailable,
      onClick: (data) => {
        if (!setAccountsGroupForEdit || !openAccountsGroupManager) {
          return;
        }

        setAccountsGroupForEdit(data);
        openAccountsGroupManager();
      },
    },
    {
      key: 'delete',
      text: t('accounts.group.delete'),
      iconName: 'BucketIcon',
      onClick: (data) =>
        openConfirmDialog(t, 'remove', {
          title: t('accounts.group.delete.confirm'),
          message: t('accounts.group.delete.confirm.message', data.title),
        }).then(({ status }) => {
          if (!deleteAccountsGroup) {
            return;
          }

          if (status === 'ACCEPTED') {
            deleteAccountsGroup(data.id);
          }
        }),
      color: 'var(--text-error)',
      disabled: (data) => data.accounts.length > 0 || !isAvailable,
    },
  ];

  return { items };
};
